import React, { useRef } from 'react';
import SystemSearchSearch from '../SystemSearchSearch';

const MobileSystemSearch: React.FC = () => {
    const inputRef = useRef<HTMLInputElement>(null);
    return <SystemSearchSearch inputRef={inputRef} />;
};

export default MobileSystemSearch;
